import { ADDITIONAL_UNITS_PICKER, CLICKED_LINK, MODAL_INTERACTION } from '../../constants/event-tracking/EventKeys';
export const getClickedAdditionalUnitsPickerEvent = properties => {
  return {
    key: ADDITIONAL_UNITS_PICKER,
    properties: Object.assign({
      action: 'click'
    }, properties)
  };
};
export const getClickedLinkEvent = properties => {
  return {
    key: CLICKED_LINK,
    properties: Object.assign({
      action: 'click'
    }, properties)
  };
};
export const getModalInteractionEvent = properties => {
  return {
    key: MODAL_INTERACTION,
    properties: Object.assign({}, properties)
  };
};